<template>
  <div class="app-container">
    <el-tabs ref="tabs" type="border-card" v-model="activeName" v-tab-change:activeName="setActiveName">
      <el-tab-pane v-if="showDeviceFeedBackTab()" label="设备反馈" name="deviceFeedback">
        <device-feedback></device-feedback>
      </el-tab-pane>
      <el-tab-pane label="用户反馈" name="userFeedback">
        <user-feedback></user-feedback>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DeviceFeedback from "@/views/systemManagement/Feedback/DeviceFeedback";
import UserFeedback from "@/views/systemManagement/Feedback/UserFeedback";

export default {
  components: {
    DeviceFeedback,
    UserFeedback
  },
  created() {
    if (this.config.SHOW_DEVICE_FEEDBACK_TAB !== "true") {
      this.activeName = "userFeedback"
    }
  },
  data() {
    return {
      activeName: "deviceFeedback"
    }
  },
  methods: {
    showDeviceFeedBackTab() {
      return this.config.SHOW_DEVICE_FEEDBACK_TAB === "true";
    }
  }
}
</script>

<style scoped>

</style>